import { useCallback } from 'react';
import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';
import { PlusIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';
import { useTracking } from '@change-corgi/core-react/tracking';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

export const AddMedia: React.FC<EmptyProps> = () => {
	const {
		data: {
			petition: { slug, id },
		},
	} = usePetitionDetailsPageData();
	const track = useTracking();

	const trackMediaPromptClick = useCallback(() => {
		void track('media_prompt_clicked', {
			petition_id: `petition_${id}`,
			link_type: 'add_a_photo_button',
			view_context: 'petitions_show',
		});
	}, [track, id]);

	return (
		<div className="mx-4 mt-4 md:mx-0 md:mt-0">
			<div className="mb-2">
				<Text as="span" fontWeight="bold" className="text-typography-brand">
					<Translate value="fe.pages.petition_show.media_prompt.tip" />
				</Text>{' '}
				<Text as="span">
					<Translate value="fe.pages.petition_show.media_prompt.desc" />
				</Text>
			</div>
			<div className="border-stroke-weak rounded-medium border-2 border-dashed p-8 md:p-10">
				<div className="flex flex-col items-center justify-center">
					<Button
						as="a"
						href={`/p/${slug}/edit#media`}
						leadingIcon={<PlusIcon />}
						onClick={trackMediaPromptClick}
						size="small"
						className="mb-4"
					>
						<span className="sr-only">
							<Translate value="fe.pages.petition_show.media_prompt.button_label" />
						</span>
					</Button>
					<Text aria-hidden="true" as="span" fontWeight="bold">
						<Translate value="fe.pages.petition_show.media_prompt.button_label" />
					</Text>
				</div>
			</div>
		</div>
	);
};
